module.exports = __webpack_public_path__ + "static/media/mark_deliverd - Sheet1.1914070c.csv";